"use client";

import { useQueryClient } from "@tanstack/react-query";
import z from "zod";

import { useRequestMutation } from "../../../../../request/hooks/useRequestMutation";
import { keyCommunitiesStripeConnectStatus } from "./keyCommunitiesStripeConnectStatus";

export const communitiesStripeConnectSchema = z.object({
  url: z.string(),
});

export const useRequestMutationsCommunitiesStripeConnect = ({
  id,
}: {
  id: number;
}) => {
  const queryClient = useQueryClient();

  return {
    mutationConnect: useRequestMutation({
      mutationFnRequestProps: {
        method: "POST",
        schema: communitiesStripeConnectSchema,
        urlBackendPath: `/me/communities/${id}/stripe/connect`,
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [keyCommunitiesStripeConnectStatus({ id })],
        });
      },
    }),
  };
};
